// extracted by mini-css-extract-plugin
export var fullGrid = "_2p-3";
export var pdpPreviewContainer = "_2p-1";
export var previewContainer = "_2p-0";
export var togglePreviewContainer = "_2p-2";